import React, { useState } from 'react';
import { motion } from "framer-motion";
import { Document, Page, pdfjs } from 'react-pdf';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import "../pdfReader/pdfReader.scss"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfReader = ({ isOpen, closePdfReader, document }) => {
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <motion.div
            className={`pdfReader ${isOpen ? 'open' : ''}`}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
        >
            <motion.div
                className="modal-nav"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.2, ease: "easeOut", delay: 0.2 }}
            >
                <CloseOutlinedIcon onClick={closePdfReader} />
            </motion.div>
            <div className="modal-content">
                <Document
                    file={"https://api.kolhaupt.it/uploads/" + document}
                    onLoadSuccess={onDocumentLoadSuccess}
                    height="500"
                >
                    <Page pageNumber={pageNumber} />
                </Document>
                <div className="documentNav">
                    <button onClick={() => setPageNumber(p => Math.max(p - 1, 1))}>
                        <ChevronLeftOutlinedIcon />
                    </button>
                    <span>Seite {pageNumber} von {numPages}</span>
                    <button onClick={() => setPageNumber(p => Math.min(p + 1, numPages))}>
                        <ChevronRightOutlinedIcon />
                    </button>
                </div>
            </div>
        </motion.div>
    );
};

export default PdfReader;